import { useState } from 'react';
import { cn, Stack, Typography, useTranslate } from '@prenuvo/halo';

import { Loading } from './loading.component';

interface PatientDocIframeProps {
  className?: {
    height: string;
    maxHeight: string;
  };
  url: string;
}

export function PatientDocIframe({
  className = {
    height: 'h-[calc(100vh-128px)]',
    maxHeight: 'max-h-[calc(100vh-128px)]',
  },
  url,
}: PatientDocIframeProps) {
  const translate = useTranslate();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const show = {
    error: isError,
    loading: isLoading && !isError,
  };

  return (
    <>
      {(show.loading || show.error) && (
        <Stack className={cn('mx-auto w-full overflow-auto', className.maxHeight)}>
          {show.loading && <Loading className={cn('w-full', className.height)} />}
          {show.error && (
            <Stack
              alignment="center"
              className={cn('w-full', className.height)}
              justification="center"
            >
              <Typography translationKey="FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENT.ERROR" />
            </Stack>
          )}
        </Stack>
      )}

      <Stack
        className={cn(
          'mx-auto w-full overflow-auto',
          {
            'opacity-0': isLoading || isError,
          },
          className.maxHeight,
        )}
      >
        <iframe
          className={cn('flex w-full bg-white', className.height)}
          loading="lazy"
          onError={() => setIsError(true)}
          onLoad={() => setIsLoading(false)}
          sandbox="allow-scripts allow-same-origin"
          src={url}
          title={translate('FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENT.IFRAME_TITLE')}
        />
      </Stack>
    </>
  );
}
